import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from "react-modal";
import OtpInput from "react-otp-input";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "semantic-ui-react";
import alert from "../../../../../src/Images/NewUI/alert.png";
import {
  createOnBoardUser,
  resendOtp,
  saveManualToken,
  savePhoneNumber,
  sendBasicDetails,
} from "../../../../Redux/Authenticate/action";
import { recordEvent } from "../../../../utils/appFlyer";
import { getUserDetail } from "../../../../Redux/GeneralDetails/action";
import {
  CreditAssist,
  getDocumentStatus,
  referandearndiraction,
} from "../../../../Redux/Manual_Kyc_Details/action";
import ToastMsg from "../../../../helper/ToastMsg";
import { withRouter } from "../../../../hooks/withRouter";
import { Loader } from "../../../NewUI/Common/Loader";
import {trackOtpMobileVerified} from "../../../../utils/ga4";

const optInput = {
  display: "inline",
  float: "left",
  width: "3.3rem",
  padding: "24px 20px",
  backgroundColor: "#FFFFFF",
  border: "none",
  borderRadius: 15,
  outline: "none",
  fontWeight: 600,
  textAlign: "center",
  redirect_url: "",
  font: "Roboto",
};

const VerifyMobileNumber = (props) => {
  const navigate = useNavigate();
  const { isOpen, onRequestClose, phone_number: phoneFromProps } = props;

  const queryParams = new URLSearchParams(window.location.search);
  const phone_number = phoneFromProps || queryParams.get("phone_number");

  const isModalOpen = typeof isOpen === "boolean" ? isOpen : true;
  const handleClose =
    typeof onRequestClose === "function" ? onRequestClose : () => {};

  const [state, setState] = useState({
    minutes: 0,
    seconds: 0,
    resendOtp: false,
    otp: "",
    is_button_disabled: false,
  });
  const [isLargeScreen, setIsLargeScreen] = useState(
    window.innerWidth > 440
  );
  const [loader, setLoader] = useState(false);
  const [showProceedPopUp, setShowProceedPopup] = useState(false);
  const [maxOtpError, setMaxOtpError] = useState("");
  const [receivedKey, setReceivedKey] = useState("");
  const [iswebPerpredirect, setIswebPerpredirect] = useState("");
  const [counter, setCounter] = useState(59);

  const handleChange = (otp) => {
    if (otp?.length === 4) {
      createOnBoardUser(otp);
    }
    setState({ otp: otp });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleQueryParam = () => {
    const searchParams = new URLSearchParams(location.search);

    const referrer = searchParams.get("referrer");
    if (referrer) {
      localStorage.setItem("referrer", referrer);
    }

    const clickid = searchParams.get("clickid");
    if (clickid) {
      localStorage.setItem("clickid", clickid);
    }

    const receivedKey = searchParams.get("isLanding");
    if (receivedKey) {
      setReceivedKey(receivedKey);
      localStorage.setItem("receivedKey", receivedKey);
      localStorage.setItem("fromPlJourney", receivedKey);
    } else {
      const storedKey = localStorage.getItem("receivedKey");
      if (storedKey) {
        setReceivedKey(storedKey);
      }
    }
  };

  useEffect(() => {
    handleQueryParam();

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    }
  }, []);

  const handleReferandEarn = (token) => {
    console.log("im inside referand earn");
    localStorage.setItem("gpay_token", token);
    localStorage.setItem("gpay_token_new", token);

    props
      .referandearndiraction(token)
      .then((res) => {
        console.log(res, "res of web view url");

        setTimeout(() => {
          window.location.href = res.data.url;
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    const plKeynew = localStorage.getItem("isFromPlJourney");
    const isPerpRedirect = localStorage.getItem("webPerp");
    setIswebPerpredirect(isPerpRedirect);
    if (localStorage.getItem("gpay_token")) {
      if (plKeynew === "true") {
        if (localStorage.getItem("iscibilform") === "true") {
          window.location.href = `/creditlimit`;
        } else window.location.href = `/dashboard_s`;
      } else if (plKeynew !== "true") {
        if (localStorage.getItem("cibilfalsenblocked")) {
          navigate("/dashboard_s");
        } else {
          if (localStorage.getItem("iscibilform") === "true") {
            window.location.href = `/creditlimit`;
          } else {
            navigate("/dashboard_s");
          }
        }
      } else {
        console.log("1 - alertt");

        setTimeout(() => {
          navigate("/dashboard_s");
        }, 100);
      }
    }
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter, localStorage.getItem("token")]);

  const createOnBoardUser = (otp_input) => {
    setLoader(true);
    localStorage.setItem("phone_number", phone_number);

    props
      .createOnBoardUser({
        otp: otp_input,
        phone_number: Number(phone_number),
        utm_campaign: localStorage.getItem("utm_campaign"),
        utm_source: localStorage.getItem("utm_source"),
        utm_medium: localStorage.getItem("utm_medium"),
        ...(localStorage.getItem("referrer") && localStorage.getItem("referrer") !== "null" && { referral_code: localStorage.getItem("referrer") }),
        ...(localStorage.getItem("partner_id") && { partner_id: localStorage.getItem("partner_id") }),
      })
      .then((result) => {
        trackOtpMobileVerified();
        if (result?.phone_number_verified) {
              recordEvent({ eventName: "otp_mobile_verified",
                 eventParams: { Platform: "web" },});
          localStorage.setItem("in_new_user", false);
          const token_ = result?.data?.token;
          setLoader(false);

          const queryParams = new URLSearchParams(window.location.search);
          const isPerpValue = queryParams.get("isPerp");

          if (isPerpValue === true) {
            props
              .referandearndiraction(token_)
              .then((res) => {
                window.location.href = res.data.url;
              })
              .catch((err) => {
                console.error("Error in referandearndiraction:", err);
              });
          }

          localStorage.setItem("gpay_token", token_);
          props.saveManualToken(token_);
          props.savePhoneNumber({ phone_number });

          

          props
            .getUserDetail(token_)
            .then((res) => {
                console.log("Sending basic details in verify otp",res);
     
              // Send AppsFlyer ID to backend after OTP verification
            props.sendBasicDetails(token_,res?.data?.data?.id)
              .catch(err => {
                console.error('Failed to send AppsFlyer ID:', err);
              });

            

              const nv_data = res?.data?.data?.customusermodel;
              const user_data_common = {
                mobile: `+91${nv_data?.phone_number}`,
                email: res?.data?.data?.email,
                name: `${nv_data?.first_name} ${nv_data?.last_name}`,
                registrationStartDate: res?.data?.data?.created_at,
                "preferred language": "en",
              };

              

              const user_data = nv_data?.gender
                ? {
                    ...user_data_common,
                    gender: nv_data?.gender,
                    birth_date: nv_data?.date_of_birth,
                  }
                : user_data_common;

              // localStorage.setItem("userID", res?.data?.data?.id);
              nv("user", res?.data?.data?.id, user_data);

              nv("event", "otp_mobile_verified", {
                user_id: res?.data?.data?.id,
                mobile_hash: phone_number ? btoa(phone_number) : "",
                source: localStorage.getItem("utm_source") || document.referrer || "",
              }, "100", 1);

            })
            .catch((err) => {
              setLoader(false);
              if (err.response?.status === 401) {
                localStorage.removeItem("gpay_token");
                window.location.href = "/";
                return;
              }
            });

          props
            .getDocumentStatus(token_)
            .then((res) => {
              const plKeynew = localStorage.getItem("receivedKey");
              res.data.forEach((details) => {
                localStorage.setItem("iscibilform", details?.cibil_form);
                if (details.blocked) {
                  if (iswebPerpredirect) {
                    console.log(token_, "res of getdocstatustoken_");
                    handleReferandEarn(token_);
                  } else {
                    console.log("2 - alertt");
                    window.location.href = "/dashboard_s";
                  }
                } else {
                  if (localStorage.getItem("is_deeplink")) {
                    navigate("/personal_loan_emi");
                  } else if (details.cibil_form) {
                    if (details.karza === true) {
                      navigate("/karza");
                    } else if (plKeynew === "true") {
                      navigate("/creditlimit");
                    } else {
                      console.log("3 - alertt");
                      if (iswebPerpredirect) {
                        setTimeout(() => {
                          navigate("/dashboard_s");
                        }, 3000);
                      } else {
                        navigate("/creditlimit");
                      }
                    }
                  } else {
                    if (plKeynew === "true") {
                      if (localStorage.getItem("iscibilform") === "true") {
                        window.location.href = `/creditlimit`;
                      } else window.location.href = `/completeprofilenew`;
                      navigate("/dashboard_s");
                    } else {
                      console.log("4 - alertt");
                      navigate("/dashboard_s");
                    }
                  }
                }
              });
            })
            .catch((err) => {
              setLoader(false);
              if (err.response?.status === 401) {
                localStorage.removeItem("gpay_token");
                window.location.href = "/";
              }
            });
        } else {
          navigate("/emailverify");
          localStorage.setItem("in_new_user", true);
        }
      })
      .catch((err) => {
        console.log("iminside catch of ");

        setLoader(false);
        const error = err?.response?.data?.error;

        if (!state.is_button_disabled) {
          if (error?.length > 90) {
            setMaxOtpError(error);
            setShowProceedPopup(true);
          } else {
            ToastMsg(error, "error");
          }

          setState({ is_button_disabled: true });
          setTimeout(() => {
            setState({ is_button_disabled: false });
          }, 4000);
        }
      });
  };

  const redirecttohome = () => {
    localStorage.setItem("phonenumber", phone_number);
    window.location.href = "/";
  };

  const handleResendOtp = () => {
    setState({ otp: "" });
    setCounter(59);

    props
      .resendOtp({ phone_number: phone_number })
      .then((res) => {
        ToastMsg("Otp sent successfully.", "success");
      })
      .catch((err) => {
        setState({ loader: false });
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
      });
  };

  return (
    <>
      <Modal
        isOpen={showProceedPopUp}
        className="proceed-popup justifycontentrepay"
        onRequestClose={() => setShowProceedPopup(false)}
        ariaHideApp={false}
      >
        <img src={alert} width={76} alt="failed" />
        <h3 className="mt-40">Max OTP Attempts Reached</h3>
        <span className="otppopuptext">{maxOtpError}</span>
        <div
          onClick={() => setShowProceedPopup(false)}
          className="otpmodalbtn"
        >
          Okay
        </div>
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleClose}
        className="otp-main-modal"
        overlayClassName="otp-main-overlay"
        ariaHideApp={false}
      >
        {loader ? <Loader /> : null}

        <div className="otp-main-content">
          <div className="otp-card">
            <Form className="flex-otp-mmb">
              <Form.Field className="mb-0">
                <span className="main__page font-size-18" name="otp">
                  Enter OTP
                </span>
                <br />
                <div className="mt-2">
                  <span className="sendtoo">Sent To</span>
                  <span className="sendto">{phone_number} </span>
                  <span
                    onClick={redirecttohome}
                    className="edittag mmb-gradient "
                  >
                    Edit
                  </span>
                </div>

                <div className="otpFlex my-5">
                  <OtpInput
                    containerStyle={
                      state?.otp?.length === 4
                        ? "form-allign circle-otp active"
                        : "form-allign circle-otp"
                    }
                    value={state.otp}
                    onChange={handleChange}
                    numInputs={4}
                    inputType="number"
                    renderSeparator={<span className="opacityzero">---</span>}
                    renderInput={(props) => <input {...props} style={optInput} />}
                  />
                </div>
              </Form.Field>

              <Form.Field
                // style={{
                //   textAlign: "center",
                //   margin: "auto",
                // }}
              >
                <div
                  style={{
                    textAlign: "center",
                    width: 181,
                    height: 56,
                    margin: "auto",
                  }}
                >
                  <p
                    className="receiveOTP dontreceiveOtp"
                    style={{ height: "auto", marginBottom: "0" }}
                  >
                    Didn’t receive OTP?
                  </p>
                  {counter === 0 ? (
                    <a
                      className="resendOtp textdecorUnderline mmb-gradient "
                      onClick={handleResendOtp}
                      style={{ cursor: "pointer" }}
                    >
                      Re-send
                    </a>
                  ) : (
                    <a
                      className="resendBtn"
                      style={{ color: "#979797" }}
                    >
                      {" "}
                      Re-send in {" 0:"}
                      {counter < 10 ? `0${counter}` : counter}s
                    </a>
                  )}
                </div>
              </Form.Field>

              <div className="otp-footer">
                {state?.otp !== "" && state?.otp?.length === 4 ? (
                  <button
                    disabled={state.is_button_disabled}
                    className="bg-orange text-white newbtnDesignsign font700 py-6 otp-footer-btn"
                  >
                    Confirm
                  </button>
                ) : (
                  <button className="bg-orange text-white newbtnDesignsign font700 py-6 otp-footer-btn">
                    Confirm
                  </button>
                )}
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps, {
  resendOtp,
  createOnBoardUser,
  getDocumentStatus,
  getUserDetail,
  CreditAssist,
  saveManualToken,
  referandearndiraction,
  savePhoneNumber,
  sendBasicDetails,
})(VerifyMobileNumber));
